import React from "react";
import classes from "./EmptyView.scss";
import { Button } from "@toddle-edu/ds-web";
import PropTypes from "prop-types";
import { useI18n } from "Hooks";

const getImageStyle = size => {
  switch (size) {
    case "small":
      return { height: 200, width: 280 };
    case "x-small":
      return { height: 200, width: 184 };
    case "large":
    default:
      return { height: 200, width: 320 };
  }
};

const getEmptyTextStyle = size => {
  switch (size) {
    case "small":
    case "x-small":
      return { fontSize: "1.5rem" };
    case "large":
      return { maxWidth: 544 };
    default:
      return {};
  }
};

const getEmptyHeaderTextStyle = ({ size, emptyText }) => {
  switch (size) {
    case "small":
    case "x-small":
      return { fontSize: "1.6rem", ...(!emptyText && { marginBottom: 32 }) };
    default:
      return {};
  }
};

const BLANK_OBJECT = {};

const EmptyView = ({
  emptyText,
  emptyHeaderText,
  buttonText,
  onButtonClick,
  containerStyle,
  showButton,
  emptyImageUrl,
  size,
  buttonVariant,
  testId,
  customImageStyles,
  customEmptyTextStyle,
}) => {
  const { t } = useI18n(["common"]);
  const imageStyles = {
    ...getImageStyle(size),
    ...customImageStyles,
  };
  const emptyTextStyles = {
    ...getEmptyTextStyle(size),
    ...customEmptyTextStyle,
  };
  return (
    <div className={classes.container} style={containerStyle}>
      <div className={classes.innerContainer}>
        <img
          src={emptyImageUrl}
          style={imageStyles}
          alt={t("common:image_not_found")}
        />
        {!!emptyHeaderText && (
          <div
            className={classes.headerText}
            style={getEmptyHeaderTextStyle({ size, emptyText })}
          >
            {emptyHeaderText}
          </div>
        )}
        {!!emptyText && (
          <div className={classes.emptyText} style={emptyTextStyles}>
            {emptyText}
          </div>
        )}
        {showButton && (
          <Button
            variant={buttonVariant}
            onClick={onButtonClick}
            size={"medium"}
            testId={`${testId}:emptyView`}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

EmptyView.propTypes = {
  emptyText: PropTypes.string,
  emptyHeaderText: PropTypes.any,
  showButton: PropTypes.bool,
  buttonText: PropTypes.string,
  emptyImageUrl: PropTypes.any,
  containerStyle: PropTypes.object,
};

EmptyView.defaultProps = {
  containerStyle: {},
  buttonText: "",
  emptyHeaderText: "",
  emptyText: "",
  showButton: false,
  buttonVariant: "primary",
  customImageStyles: BLANK_OBJECT,
  customEmptyTextStyle: BLANK_OBJECT,
};

export default EmptyView;
